// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file client/payments.proto (package client, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../buf/validate/validate_pb";
import type { OrderMessage, OrderMessageSchema, OrderStatus } from "../common/billing_pb";
import { file_common_billing } from "../common/billing_pb";
import type { Pagination, SortDirection } from "../common/common_pb";
import { file_common_common } from "../common/common_pb";
import type { CurrencyCode, CurrencyType, NetworkCode, PaymentDirection, PaymentMethodMessage, PaymentProvider } from "../common/payment_pb";
import { file_common_payment } from "../common/payment_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file client/payments.proto.
 */
export const file_client_payments: GenFile = /*@__PURE__*/
  fileDesc("ChVjbGllbnQvcGF5bWVudHMucHJvdG8SBmNsaWVudCLaBAoZTGlzdFBheW1lbnRNZXRob2RzUmVxdWVzdBIwCglkaXJlY3Rpb24YASABKA4yGC5jb21tb24uUGF5bWVudERpcmVjdGlvbkgAiAEBEi4KCHByb3ZpZGVyGAIgASgOMhcuY29tbW9uLlBheW1lbnRQcm92aWRlckgBiAEBEicKBHR5cGUYAyABKA4yFC5jb21tb24uQ3VycmVuY3lUeXBlSAKIAQESKwoIY3VycmVuY3kYBCABKA4yFC5jb21tb24uQ3VycmVuY3lDb2RlSAOIAQESKQoHbmV0d29yaxgFIAEoDjITLmNvbW1vbi5OZXR3b3JrQ29kZUgEiAEBEhQKB2NvdW50cnkYBiABKAlIBYgBARIXCgptaW5fYW1vdW50GAcgASgJSAaIAQESFwoKbWF4X2Ftb3VudBgIIAEoCUgHiAEBEhYKCWlzX2FjdGl2ZRgJIAEoCEgIiAEBEhQKB3NvcnRfYnkYCiABKAlICYgBARInCghzb3J0X2RpchgLIAEoDjIVLmNvbW1vbi5Tb3J0RGlyZWN0aW9uEisKCnBhZ2luYXRpb24YDCABKAsyEi5jb21tb24uUGFnaW5hdGlvbkgKiAEBQgwKCl9kaXJlY3Rpb25CCwoJX3Byb3ZpZGVyQgcKBV90eXBlQgsKCV9jdXJyZW5jeUIKCghfbmV0d29ya0IKCghfY291bnRyeUINCgtfbWluX2Ftb3VudEINCgtfbWF4X2Ftb3VudEIMCgpfaXNfYWN0aXZlQgoKCF9zb3J0X2J5Qg0KC19wYWdpbmF0aW9uIogBChpMaXN0UGF5bWVudE1ldGhvZHNSZXNwb25zZRIqCgRkYXRhGAEgAygLMhwuY29tbW9uLlBheW1lbnRNZXRob2RNZXNzYWdlEiYKCnBhZ2luYXRpb24YAiABKAsyEi5jb21tb24uUGFnaW5hdGlvbhIWCg5jYXRlZ29yeV9vcmRlchgDIAMoCSL1AgoTTGlzdERlcG9zaXRzUmVxdWVzdBIwCg1jdXJyZW5jeV90eXBlGAEgASgOMhQuY29tbW9uLkN1cnJlbmN5VHlwZUgAiAEBEiMKBnN0YXR1cxgCIAMoDjITLmNvbW1vbi5PcmRlclN0YXR1cxIWCglkYXRlX2Zyb20YAyABKAlIAYgBARIUCgdkYXRlX3RvGAQgASgJSAKIAQESFwoKcGF5bWVudF9pZBgFIAEoCUgDiAEBEhQKB3NvcnRfYnkYBiABKAlIBIgBARInCghzb3J0X2RpchgHIAEoDjIVLmNvbW1vbi5Tb3J0RGlyZWN0aW9uEisKCnBhZ2luYXRpb24YCCABKAsyEi5jb21tb24uUGFnaW5hdGlvbkgFiAEBQhAKDl9jdXJyZW5jeV90eXBlQgwKCl9kYXRlX2Zyb21CCgoIX2RhdGVfdG9CDQoLX3BheW1lbnRfaWRCCgoIX3NvcnRfYnlCDQoLX3BhZ2luYXRpb24i+AIKFkxpc3RXaXRoZHJhd2Fsc1JlcXVlc3QSMAoNY3VycmVuY3lfdHlwZRgBIAEoDjIULmNvbW1vbi5DdXJyZW5jeVR5cGVIAIgBARIjCgZzdGF0dXMYAiADKA4yEy5jb21tb24uT3JkZXJTdGF0dXMSFgoJZGF0ZV9mcm9tGAMgASgJSAGIAQESFAoHZGF0ZV90bxgEIAEoCUgCiAEBEhcKCnBheW1lbnRfaWQYBSABKAlIA4gBARIUCgdzb3J0X2J5GAYgASgJSASIAQESJwoIc29ydF9kaXIYByABKA4yFS5jb21tb24uU29ydERpcmVjdGlvbhIrCgpwYWdpbmF0aW9uGAggASgLMhIuY29tbW9uLlBhZ2luYXRpb25IBYgBAUIQCg5fY3VycmVuY3lfdHlwZUIMCgpfZGF0ZV9mcm9tQgoKCF9kYXRlX3RvQg0KC19wYXltZW50X2lkQgoKCF9zb3J0X2J5Qg0KC19wYWdpbmF0aW9uImAKEkxpc3RPcmRlcnNSZXNwb25zZRIiCgRkYXRhGAEgAygLMhQuY29tbW9uLk9yZGVyTWVzc2FnZRImCgpwYWdpbmF0aW9uGAIgASgLMhIuY29tbW9uLlBhZ2luYXRpb24iqwEKFENyZWF0ZURlcG9zaXRSZXF1ZXN0EiMKEXBheW1lbnRfbWV0aG9kX2lkGAEgASgJQgi6SAVyA7ABARIXCgZhbW91bnQYAiABKAlCB7pIBHICEAESIAoKcHJvbW9fY29kZRgDIAEoCUIHukgEcgIYZEgAiAEBEhsKBG1ldGEYBCABKAlCCLpIBXIDGOgHSAGIAQFCDQoLX3Byb21vX2NvZGVCBwoFX21ldGEiMQoRR2V0RGVwb3NpdFJlcXVlc3QSHAoKZGVwb3NpdF9pZBgBIAEoCUIIukgFcgOwAQEiNQoVQ29uZmlybURlcG9zaXRSZXF1ZXN0EhwKCmRlcG9zaXRfaWQYASABKAlCCLpIBXIDsAEBIsQCChdDcmVhdGVXaXRoZHJhd2FsUmVxdWVzdBIjChFwYXltZW50X21ldGhvZF9pZBgBIAEoCUIIukgFcgOwAQESFwoGYW1vdW50GAIgASgJQge6SARyAhABEh4KB2FkZHJlc3MYAyABKAlCCLpIBXIDGP8BSACIAQESGwoEbmFtZRgEIAEoCUIIukgFcgMY/wFIAYgBARIcCgplbWFpbF9jb2RlGAYgASgJQgi6SAVyA5gBBhIWCgl0b3RwX2NvZGUYByABKAlIAogBARIgCglyZWNpcGllbnQYCSABKAlCCLpIBXIDGPQDSAOIAQFCCgoIX2FkZHJlc3NCBwoFX25hbWVCDAoKX3RvdHBfY29kZUIMCgpfcmVjaXBpZW50SgQIBRAGSgQICBAJUgtjYXJkX251bWJlclIMcGhvbmVfbnVtYmVyIjcKFEdldFdpdGhkcmF3YWxSZXF1ZXN0Eh8KDXdpdGhkcmF3YWxfaWQYASABKAlCCLpIBXIDsAEBIjoKF0NhbmNlbFdpdGhkcmF3YWxSZXF1ZXN0Eh8KDXdpdGhkcmF3YWxfaWQYASABKAlCCLpIBXIDsAEBIk0KDUdldEZlZVJlcXVlc3QSIwoRcGF5bWVudF9tZXRob2RfaWQYASABKAlCCLpIBXIDsAEBEhcKBmFtb3VudBgCIAEoCUIHukgEcgIQASIyCg5HZXRGZWVSZXNwb25zZRILCgNmZWUYASABKAkSEwoLeW91X3JlY2VpdmUYAiABKAkiHwodR2V0RGVwb3NpdEF2YWlsYWJpbGl0eVJlcXVlc3QiMwoaRGVwb3NpdEF2YWlsYWJpbGl0eU1lc3NhZ2USFQoNaGFzX2RlcG9zaXRlZBgBIAEoCDLNBgoSUGF5bWVudHNSUENTZXJ2aWNlElsKEkxpc3RQYXltZW50TWV0aG9kcxIhLmNsaWVudC5MaXN0UGF5bWVudE1ldGhvZHNSZXF1ZXN0GiIuY2xpZW50Lkxpc3RQYXltZW50TWV0aG9kc1Jlc3BvbnNlEkcKDExpc3REZXBvc2l0cxIbLmNsaWVudC5MaXN0RGVwb3NpdHNSZXF1ZXN0GhouY2xpZW50Lkxpc3RPcmRlcnNSZXNwb25zZRJDCg1DcmVhdGVEZXBvc2l0EhwuY2xpZW50LkNyZWF0ZURlcG9zaXRSZXF1ZXN0GhQuY29tbW9uLk9yZGVyTWVzc2FnZRI9CgpHZXREZXBvc2l0EhkuY2xpZW50LkdldERlcG9zaXRSZXF1ZXN0GhQuY29tbW9uLk9yZGVyTWVzc2FnZRJFCg5Db25maXJtRGVwb3NpdBIdLmNsaWVudC5Db25maXJtRGVwb3NpdFJlcXVlc3QaFC5jb21tb24uT3JkZXJNZXNzYWdlEk0KD0xpc3RXaXRoZHJhd2FscxIeLmNsaWVudC5MaXN0V2l0aGRyYXdhbHNSZXF1ZXN0GhouY2xpZW50Lkxpc3RPcmRlcnNSZXNwb25zZRJJChBDcmVhdGVXaXRoZHJhd2FsEh8uY2xpZW50LkNyZWF0ZVdpdGhkcmF3YWxSZXF1ZXN0GhQuY29tbW9uLk9yZGVyTWVzc2FnZRJDCg1HZXRXaXRoZHJhd2FsEhwuY2xpZW50LkdldFdpdGhkcmF3YWxSZXF1ZXN0GhQuY29tbW9uLk9yZGVyTWVzc2FnZRJJChBDYW5jZWxXaXRoZHJhd2FsEh8uY2xpZW50LkNhbmNlbFdpdGhkcmF3YWxSZXF1ZXN0GhQuY29tbW9uLk9yZGVyTWVzc2FnZRI3CgZHZXRGZWUSFS5jbGllbnQuR2V0RmVlUmVxdWVzdBoWLmNsaWVudC5HZXRGZWVSZXNwb25zZRJjChZHZXREZXBvc2l0QXZhaWxhYmlsaXR5EiUuY2xpZW50LkdldERlcG9zaXRBdmFpbGFiaWxpdHlSZXF1ZXN0GiIuY2xpZW50LkRlcG9zaXRBdmFpbGFiaWxpdHlNZXNzYWdlYgZwcm90bzM", [file_buf_validate_validate, file_common_billing, file_common_common, file_common_payment]);

/**
 * @generated from message client.ListPaymentMethodsRequest
 */
export type ListPaymentMethodsRequest = Message<"client.ListPaymentMethodsRequest"> & {
  /**
   * @generated from field: optional common.PaymentDirection direction = 1;
   */
  direction?: PaymentDirection;

  /**
   * @generated from field: optional common.PaymentProvider provider = 2;
   */
  provider?: PaymentProvider;

  /**
   * @generated from field: optional common.CurrencyType type = 3;
   */
  type?: CurrencyType;

  /**
   * @generated from field: optional common.CurrencyCode currency = 4;
   */
  currency?: CurrencyCode;

  /**
   * @generated from field: optional common.NetworkCode network = 5;
   */
  network?: NetworkCode;

  /**
   * @generated from field: optional string country = 6;
   */
  country?: string;

  /**
   * @generated from field: optional string min_amount = 7;
   */
  minAmount?: string;

  /**
   * @generated from field: optional string max_amount = 8;
   */
  maxAmount?: string;

  /**
   * @generated from field: optional bool is_active = 9;
   */
  isActive?: boolean;

  /**
   * @generated from field: optional string sort_by = 10;
   */
  sortBy?: string;

  /**
   * @generated from field: common.SortDirection sort_dir = 11;
   */
  sortDir: SortDirection;

  /**
   * @generated from field: optional common.Pagination pagination = 12;
   */
  pagination?: Pagination;
};

/**
 * Describes the message client.ListPaymentMethodsRequest.
 * Use `create(ListPaymentMethodsRequestSchema)` to create a new message.
 */
export const ListPaymentMethodsRequestSchema: GenMessage<ListPaymentMethodsRequest> = /*@__PURE__*/
  messageDesc(file_client_payments, 0);

/**
 * @generated from message client.ListPaymentMethodsResponse
 */
export type ListPaymentMethodsResponse = Message<"client.ListPaymentMethodsResponse"> & {
  /**
   * @generated from field: repeated common.PaymentMethodMessage data = 1;
   */
  data: PaymentMethodMessage[];

  /**
   * @generated from field: common.Pagination pagination = 2;
   */
  pagination?: Pagination;

  /**
   * Category display order, e.g. ["popular","cards","e-payments","crypto","other"]
   *
   * @generated from field: repeated string category_order = 3;
   */
  categoryOrder: string[];
};

/**
 * Describes the message client.ListPaymentMethodsResponse.
 * Use `create(ListPaymentMethodsResponseSchema)` to create a new message.
 */
export const ListPaymentMethodsResponseSchema: GenMessage<ListPaymentMethodsResponse> = /*@__PURE__*/
  messageDesc(file_client_payments, 1);

/**
 * @generated from message client.ListDepositsRequest
 */
export type ListDepositsRequest = Message<"client.ListDepositsRequest"> & {
  /**
   * @generated from field: optional common.CurrencyType currency_type = 1;
   */
  currencyType?: CurrencyType;

  /**
   * @generated from field: repeated common.OrderStatus status = 2;
   */
  status: OrderStatus[];

  /**
   * @generated from field: optional string date_from = 3;
   */
  dateFrom?: string;

  /**
   * @generated from field: optional string date_to = 4;
   */
  dateTo?: string;

  /**
   * @generated from field: optional string payment_id = 5;
   */
  paymentId?: string;

  /**
   * @generated from field: optional string sort_by = 6;
   */
  sortBy?: string;

  /**
   * @generated from field: common.SortDirection sort_dir = 7;
   */
  sortDir: SortDirection;

  /**
   * @generated from field: optional common.Pagination pagination = 8;
   */
  pagination?: Pagination;
};

/**
 * Describes the message client.ListDepositsRequest.
 * Use `create(ListDepositsRequestSchema)` to create a new message.
 */
export const ListDepositsRequestSchema: GenMessage<ListDepositsRequest> = /*@__PURE__*/
  messageDesc(file_client_payments, 2);

/**
 * @generated from message client.ListWithdrawalsRequest
 */
export type ListWithdrawalsRequest = Message<"client.ListWithdrawalsRequest"> & {
  /**
   * @generated from field: optional common.CurrencyType currency_type = 1;
   */
  currencyType?: CurrencyType;

  /**
   * @generated from field: repeated common.OrderStatus status = 2;
   */
  status: OrderStatus[];

  /**
   * @generated from field: optional string date_from = 3;
   */
  dateFrom?: string;

  /**
   * @generated from field: optional string date_to = 4;
   */
  dateTo?: string;

  /**
   * @generated from field: optional string payment_id = 5;
   */
  paymentId?: string;

  /**
   * @generated from field: optional string sort_by = 6;
   */
  sortBy?: string;

  /**
   * @generated from field: common.SortDirection sort_dir = 7;
   */
  sortDir: SortDirection;

  /**
   * @generated from field: optional common.Pagination pagination = 8;
   */
  pagination?: Pagination;
};

/**
 * Describes the message client.ListWithdrawalsRequest.
 * Use `create(ListWithdrawalsRequestSchema)` to create a new message.
 */
export const ListWithdrawalsRequestSchema: GenMessage<ListWithdrawalsRequest> = /*@__PURE__*/
  messageDesc(file_client_payments, 3);

/**
 * @generated from message client.ListOrdersResponse
 */
export type ListOrdersResponse = Message<"client.ListOrdersResponse"> & {
  /**
   * @generated from field: repeated common.OrderMessage data = 1;
   */
  data: OrderMessage[];

  /**
   * @generated from field: common.Pagination pagination = 2;
   */
  pagination?: Pagination;
};

/**
 * Describes the message client.ListOrdersResponse.
 * Use `create(ListOrdersResponseSchema)` to create a new message.
 */
export const ListOrdersResponseSchema: GenMessage<ListOrdersResponse> = /*@__PURE__*/
  messageDesc(file_client_payments, 4);

/**
 * @generated from message client.CreateDepositRequest
 */
export type CreateDepositRequest = Message<"client.CreateDepositRequest"> & {
  /**
   * @generated from field: string payment_method_id = 1;
   */
  paymentMethodId: string;

  /**
   * @generated from field: string amount = 2;
   */
  amount: string;

  /**
   * @generated from field: optional string promo_code = 3;
   */
  promoCode?: string;

  /**
   * Extra form field values as JSON: {"walletFrom": "U1234567"}
   *
   * @generated from field: optional string meta = 4;
   */
  meta?: string;
};

/**
 * Describes the message client.CreateDepositRequest.
 * Use `create(CreateDepositRequestSchema)` to create a new message.
 */
export const CreateDepositRequestSchema: GenMessage<CreateDepositRequest> = /*@__PURE__*/
  messageDesc(file_client_payments, 5);

/**
 * @generated from message client.GetDepositRequest
 */
export type GetDepositRequest = Message<"client.GetDepositRequest"> & {
  /**
   * @generated from field: string deposit_id = 1;
   */
  depositId: string;
};

/**
 * Describes the message client.GetDepositRequest.
 * Use `create(GetDepositRequestSchema)` to create a new message.
 */
export const GetDepositRequestSchema: GenMessage<GetDepositRequest> = /*@__PURE__*/
  messageDesc(file_client_payments, 6);

/**
 * @generated from message client.ConfirmDepositRequest
 */
export type ConfirmDepositRequest = Message<"client.ConfirmDepositRequest"> & {
  /**
   * @generated from field: string deposit_id = 1;
   */
  depositId: string;
};

/**
 * Describes the message client.ConfirmDepositRequest.
 * Use `create(ConfirmDepositRequestSchema)` to create a new message.
 */
export const ConfirmDepositRequestSchema: GenMessage<ConfirmDepositRequest> = /*@__PURE__*/
  messageDesc(file_client_payments, 7);

/**
 * @generated from message client.CreateWithdrawalRequest
 */
export type CreateWithdrawalRequest = Message<"client.CreateWithdrawalRequest"> & {
  /**
   * @generated from field: string payment_method_id = 1;
   */
  paymentMethodId: string;

  /**
   * @generated from field: string amount = 2;
   */
  amount: string;

  /**
   * @generated from field: optional string address = 3;
   */
  address?: string;

  /**
   * @generated from field: optional string name = 4;
   */
  name?: string;

  /**
   * @generated from field: string email_code = 6;
   */
  emailCode: string;

  /**
   * @generated from field: optional string totp_code = 7;
   */
  totpCode?: string;

  /**
   * @generated from field: optional string recipient = 9;
   */
  recipient?: string;
};

/**
 * Describes the message client.CreateWithdrawalRequest.
 * Use `create(CreateWithdrawalRequestSchema)` to create a new message.
 */
export const CreateWithdrawalRequestSchema: GenMessage<CreateWithdrawalRequest> = /*@__PURE__*/
  messageDesc(file_client_payments, 8);

/**
 * @generated from message client.GetWithdrawalRequest
 */
export type GetWithdrawalRequest = Message<"client.GetWithdrawalRequest"> & {
  /**
   * @generated from field: string withdrawal_id = 1;
   */
  withdrawalId: string;
};

/**
 * Describes the message client.GetWithdrawalRequest.
 * Use `create(GetWithdrawalRequestSchema)` to create a new message.
 */
export const GetWithdrawalRequestSchema: GenMessage<GetWithdrawalRequest> = /*@__PURE__*/
  messageDesc(file_client_payments, 9);

/**
 * @generated from message client.CancelWithdrawalRequest
 */
export type CancelWithdrawalRequest = Message<"client.CancelWithdrawalRequest"> & {
  /**
   * @generated from field: string withdrawal_id = 1;
   */
  withdrawalId: string;
};

/**
 * Describes the message client.CancelWithdrawalRequest.
 * Use `create(CancelWithdrawalRequestSchema)` to create a new message.
 */
export const CancelWithdrawalRequestSchema: GenMessage<CancelWithdrawalRequest> = /*@__PURE__*/
  messageDesc(file_client_payments, 10);

/**
 * @generated from message client.GetFeeRequest
 */
export type GetFeeRequest = Message<"client.GetFeeRequest"> & {
  /**
   * @generated from field: string payment_method_id = 1;
   */
  paymentMethodId: string;

  /**
   * @generated from field: string amount = 2;
   */
  amount: string;
};

/**
 * Describes the message client.GetFeeRequest.
 * Use `create(GetFeeRequestSchema)` to create a new message.
 */
export const GetFeeRequestSchema: GenMessage<GetFeeRequest> = /*@__PURE__*/
  messageDesc(file_client_payments, 11);

/**
 * @generated from message client.GetFeeResponse
 */
export type GetFeeResponse = Message<"client.GetFeeResponse"> & {
  /**
   * @generated from field: string fee = 1;
   */
  fee: string;

  /**
   * @generated from field: string you_receive = 2;
   */
  youReceive: string;
};

/**
 * Describes the message client.GetFeeResponse.
 * Use `create(GetFeeResponseSchema)` to create a new message.
 */
export const GetFeeResponseSchema: GenMessage<GetFeeResponse> = /*@__PURE__*/
  messageDesc(file_client_payments, 12);

/**
 * @generated from message client.GetDepositAvailabilityRequest
 */
export type GetDepositAvailabilityRequest = Message<"client.GetDepositAvailabilityRequest"> & {
};

/**
 * Describes the message client.GetDepositAvailabilityRequest.
 * Use `create(GetDepositAvailabilityRequestSchema)` to create a new message.
 */
export const GetDepositAvailabilityRequestSchema: GenMessage<GetDepositAvailabilityRequest> = /*@__PURE__*/
  messageDesc(file_client_payments, 13);

/**
 * @generated from message client.DepositAvailabilityMessage
 */
export type DepositAvailabilityMessage = Message<"client.DepositAvailabilityMessage"> & {
  /**
   * @generated from field: bool has_deposited = 1;
   */
  hasDeposited: boolean;
};

/**
 * Describes the message client.DepositAvailabilityMessage.
 * Use `create(DepositAvailabilityMessageSchema)` to create a new message.
 */
export const DepositAvailabilityMessageSchema: GenMessage<DepositAvailabilityMessage> = /*@__PURE__*/
  messageDesc(file_client_payments, 14);

/**
 * @generated from service client.PaymentsRPCService
 */
export const PaymentsRPCService: GenService<{
  /**
   * @generated from rpc client.PaymentsRPCService.ListPaymentMethods
   */
  listPaymentMethods: {
    methodKind: "unary";
    input: typeof ListPaymentMethodsRequestSchema;
    output: typeof ListPaymentMethodsResponseSchema;
  },
  /**
   * @generated from rpc client.PaymentsRPCService.ListDeposits
   */
  listDeposits: {
    methodKind: "unary";
    input: typeof ListDepositsRequestSchema;
    output: typeof ListOrdersResponseSchema;
  },
  /**
   * @generated from rpc client.PaymentsRPCService.CreateDeposit
   */
  createDeposit: {
    methodKind: "unary";
    input: typeof CreateDepositRequestSchema;
    output: typeof OrderMessageSchema;
  },
  /**
   * @generated from rpc client.PaymentsRPCService.GetDeposit
   */
  getDeposit: {
    methodKind: "unary";
    input: typeof GetDepositRequestSchema;
    output: typeof OrderMessageSchema;
  },
  /**
   * @generated from rpc client.PaymentsRPCService.ConfirmDeposit
   */
  confirmDeposit: {
    methodKind: "unary";
    input: typeof ConfirmDepositRequestSchema;
    output: typeof OrderMessageSchema;
  },
  /**
   * @generated from rpc client.PaymentsRPCService.ListWithdrawals
   */
  listWithdrawals: {
    methodKind: "unary";
    input: typeof ListWithdrawalsRequestSchema;
    output: typeof ListOrdersResponseSchema;
  },
  /**
   * @generated from rpc client.PaymentsRPCService.CreateWithdrawal
   */
  createWithdrawal: {
    methodKind: "unary";
    input: typeof CreateWithdrawalRequestSchema;
    output: typeof OrderMessageSchema;
  },
  /**
   * @generated from rpc client.PaymentsRPCService.GetWithdrawal
   */
  getWithdrawal: {
    methodKind: "unary";
    input: typeof GetWithdrawalRequestSchema;
    output: typeof OrderMessageSchema;
  },
  /**
   * @generated from rpc client.PaymentsRPCService.CancelWithdrawal
   */
  cancelWithdrawal: {
    methodKind: "unary";
    input: typeof CancelWithdrawalRequestSchema;
    output: typeof OrderMessageSchema;
  },
  /**
   * @generated from rpc client.PaymentsRPCService.GetFee
   */
  getFee: {
    methodKind: "unary";
    input: typeof GetFeeRequestSchema;
    output: typeof GetFeeResponseSchema;
  },
  /**
   * @generated from rpc client.PaymentsRPCService.GetDepositAvailability
   */
  getDepositAvailability: {
    methodKind: "unary";
    input: typeof GetDepositAvailabilityRequestSchema;
    output: typeof DepositAvailabilityMessageSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_client_payments, 0);

